/**
 * <lu-model-picker data-mode="shared|override">
 *   <button data-brand="iPhone">iPhone</button>
 *   <button data-brand="Samsung">Samsung</button>
 *   <select data-model-select></select>
 *   <div data-picker-note hidden>...</div>
 * </lu-model-picker>
 *
 * "shared" mode reads/writes window.LuneliStore (brand/model shared with the
 * rest of the page). "override" mode mirrors the shared store until the
 * shopper interacts with this picker directly, then keeps its own value
 * (used by the Giving Back / Adrenaline Daisy section).
 */
(function () {
  if (customElements.get('lu-model-picker')) return;

  class LuneliModelPicker extends HTMLElement {
    connectedCallback() {
      // luneli-store.js is loaded before this file, but guard anyway so a
      // load-order change degrades to an inert picker instead of a crash.
      if (!window.LuneliStore || !window.LUNELI_MODELS) {
        console.warn('[Lūneli] model picker loaded before luneli-store.js');
        return;
      }

      this.mode = this.dataset.mode || 'shared';
      this.brandButtons = Array.prototype.slice.call(this.querySelectorAll('[data-brand]'));
      this.select = this.querySelector('[data-model-select]');
      this.noteEl = this.querySelector('[data-picker-note]');
      this.touched = false;
      this.local = { brand: window.LuneliStore.get().brand, model: '' };

      this.brandButtons.forEach(
        function (btn) {
          btn.addEventListener('click', this.onBrandClick.bind(this, btn.dataset.brand));
        }.bind(this)
      );
      if (this.select) {
        this.select.addEventListener('change', this.onModelChange.bind(this, undefined));
      }

      this.unsubShared = window.LuneliStore.subscribe(
        function (state) {
          if (this.mode === 'shared' || !this.touched) this.renderFromState(state);
        }.bind(this)
      );
      this.renderFromState(window.LuneliStore.get());
    }

    disconnectedCallback() {
      if (this.unsubShared) this.unsubShared();
    }

    renderFromState(state) {
      var brand = state.brand;
      var model = state.model;
      this.brandButtons.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.dataset.brand === brand);
      });
      if (this.select) {
        var models = window.LUNELI_MODELS[brand] || [];
        if (this.select.dataset.brand !== brand) {
          this.select.dataset.brand = brand;
          var opts = '<option value="" disabled' + (model ? '' : ' selected') + '>Choose ' + brand + ' Model</option>';
          models.forEach(function (pair) {
            opts += '<option value="' + pair[0] + '">' + pair[0] + '</option>';
          });
          this.select.innerHTML = opts;
        }
        this.select.value = model || '';
      }
      if (this.noteEl) this.noteEl.hidden = !(this.mode === 'override' && this.touched);
      this.dispatchEvent(new CustomEvent('lu-picker-change', { bubbles: true, detail: { brand: brand, model: model } }));
    }

    onBrandClick(brand) {
      if (this.mode === 'shared') {
        window.LuneliStore.set({ brand: brand, model: '' });
        return;
      }
      this.touched = true;
      this.local = { brand: brand, model: this.defaultModelFor(brand) };
      this.renderFromState(this.local);
    }

    onModelChange(_unused, event) {
      var model = event.target.value;
      if (this.mode === 'shared') {
        window.LuneliStore.set({ model: model });
        return;
      }
      this.touched = true;
      this.local = { brand: this.local.brand, model: model };
      this.renderFromState(this.local);
    }

    defaultModelFor(brand) {
      var models = window.LUNELI_MODELS[brand] || [];
      var preferred = brand === 'iPhone' ? 'iPhone 17 Pro' : 'Samsung Galaxy S25 Ultra';
      for (var i = 0; i < models.length; i++) if (models[i][0] === preferred) return preferred;
      return models.length ? models[models.length - 1][0] : '';
    }
  }

  customElements.define('lu-model-picker', LuneliModelPicker);
})();
